/**文献标注头部栏 */
<template>
  <div class="header-bar">
    <div class="header-title">
      <div class="title">文献标注</div>
    </div>
    <div class="header-operate">
      <el-button
        class="export-button"
        type="default"
        @click="handleClickExport"
      >
        <i class="iconfont icon-daochu1" />
        批量导出
      </el-button>
      <el-button
        class="remove-button"
        type="default"
        @click="handleClickBatchDelete"
      >
        <i class="iconfont icon-shanchu" />
        批量删除
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, watch, defineEmits } from "vue";
import VueCookies from "vue-cookies";
import { useRoute, useRouter } from "vue-router";
import { confirmBox } from "@/utils/messageBox.js";
import { bus } from "@/utils/mitt.js";
import { ElMessage, ElNotification } from "element-plus";
import { httpPost, baseUrl } from "@/api/httpService.js";
import {
  SHARE_THEME_PERMISSION,
  SHARE_THEME_STATUS,
} from "@/constant/share_theme.js";

const router = useRouter();

const emits = defineEmits(["refresh"]);

const props = defineProps({
  selectList: {
    type: Array,
    default: () => [],
  },
});

//获取表格选中的项
const itemSelectList = ref([]);
const idSelectList = ref([]);
watch(
  () => props.selectList,
  (newVal, oldVal) => {
    itemSelectList.value = newVal;
    idSelectList.value = newVal.map((element) => {
      return element.literatureMarkUid;
    });
  },
  { immediate: true, deep: true }
);

const refresh = () => {
  emits("refresh");
};

//批量导出
const handleClickExport = async () => {
  if (idSelectList.value.length == 0) {
    ElMessage.warning("请选择标记");
  } else {
    window.location.href =
      baseUrl +
      "literatureMark/v1/exportMark?literatureMarkUidList=" +
      idSelectList.value +
      "&access_token=" +
      VueCookies.get("tokenWeb");
    // ElMessage.success("导出成功");
  }
};

//批量删除
const handleClickBatchDelete = () => {
  if (idSelectList.value.length == 0) {
    ElMessage.warning("请选择标记");
  } else {
    //筛选出有操作权限的标记
    let idList = itemSelectList.value
      .filter(
        (item) =>
          item.permission != SHARE_THEME_PERMISSION.VIEW && item.isControl
      )
      .map((element) => {
        return element.literatureMarkUid;
      });
    if (idList.length > 0) {
      if (itemSelectList.value.length !== idList.length) {
        ElMessage.warning("存在不能删除的标记，已为您忽略");
      }
      confirmBox(`确认删除选中标记吗？`).then(async () => {
        let params = {
          literatureMarkUidList: idList,
        };
        let res = await httpPost("/literatureMark/v1/batchDeleteMark", params);
        if (res.code == 0) {
          ElMessage.success("删除成功");
          refresh();
        }
      });
    } else {
      ElMessage.warning("当前没有可删除的标记");
    }
  }
};
</script>

<style lang="scss" scoped>
.header-bar {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  position: relative;
  .header-title {
    font-size: 18px;
    font-weight: 550;
    display: flex;
    align-items: center;
    .title {
      @include hidden-with-ellipsis();
      max-width: 380px;
    }
  }
  .header-operate {
    display: flex;
    .export-button {
      .iconfont {
        margin-right: 5px;
        font-size: 14px;
      }
    }
    .remove-button {
      margin-left: 15px;
      .iconfont {
        margin-right: 5px;
        font-size: 14px;
      }
    }
  }
}
</style>
